import RaildaysLayout from "Raildays/Components/RaildaysLayout.js";
import RaildaysContactView from "Raildays/Pages/RaildaysContactView.js";
import RaildaysEventDetailView from "Raildays/Pages/RaildaysEventDetailView.js";
import RaildaysEventsView from "Raildays/Pages/RaildaysEventsView.js";
import RaildaysExperienceDetailView from "Raildays/Pages/RaildaysExperienceDetailView.js";
import RaildaysExperiencesView from "Raildays/Pages/RaildaysExperiencesView.js";
import RaildaysFeedbackQuestionsView from "Raildays/Pages/RaildaysFeedbackQuestionsView.js";
import RaildaysFeedbackView from "Raildays/Pages/RaildaysFeedbackView.js";
import RaildaysHomeView from "Raildays/Pages/RaildaysHomeView.js";
import RaildaysRailwaysView from "Raildays/Pages/RaildaysRailwaysView.js";
import RaildaysSearchView from "Raildays/Pages/RaildaysSearchView.js";
import RaildaysStatusPage from "Raildays/Pages/RaildaysStatusPage.js";
import RailwayDetailView from "Raildays/Pages/RailwayDetailView.js";
import RailwayFaqsView from "Raildays/Pages/RailwayFaqsView.js";
import {useEffect} from "react";
import {Route, Routes} from "react-router-dom";

import "leaflet/dist/leaflet.css";
import dLoading from "Dispatchers/dLoading";

import Raildays404Page from "./Pages/Raildays404";

const RaildaysView = () => {

	useEffect(() => {
		dLoading(false);
	}, []);


	return (
		<Routes>
			<Route element={<RaildaysLayout />}>
				<Route index element={<RaildaysHomeView />} />
				<Route path="railways" element={<RaildaysRailwaysView />} />
				<Route path="railways/:slug/faqs" element={<RailwayFaqsView />} />
				<Route path="railways/:slug" element={<RailwayDetailView />} />
				<Route path="search" element={<RaildaysSearchView />} />
				<Route
					path="error"
					element={
						<RaildaysStatusPage
							code="500"
							title="Something went wrong"
							message="We are having trouble loading Raildays right now. Please try again shortly."
						/>
					}
				/>
				<Route
					path="maintenance"
					element={
						<RaildaysStatusPage
							code="503"
							title="We will be right back"
							message="Raildays is undergoing scheduled maintenance. Please check back soon."
						/>
					}
				/>
				<Route path="events" element={<RaildaysEventsView />} />
				<Route path="events/:id" element={<RaildaysEventDetailView />} />
				<Route path="experiences" element={<RaildaysExperiencesView />} />
				<Route path="experiences/:id" element={<RaildaysExperienceDetailView />} />
				<Route path="feedback" element={<RaildaysFeedbackView />} />
				<Route path="feedback/:salesOrderUuid/:visitDate" element={<RaildaysFeedbackView />} />
				<Route path="feedback-questions/:feedbackId" element={<RaildaysFeedbackQuestionsView />} />
				<Route path="contact" element={<RaildaysContactView />} />
				<Route path="*" element={<Raildays404Page />} />
			</Route>
		</Routes>
	);
};

export default RaildaysView;
